<div class="form-group" *ngFor="let groupPermission of groupPermissions; let index = index">
  <label>{{ groupPermission.userGroup.name }}</label>
  <tsq-chips-radio [options]="options"
                   [selected]="getSelected(index)"
                   (selectedChange)="onSelected($event, index)"></tsq-chips-radio>
</div>
